import { gql } from 'apollo-boost';

export const uaTraitsQuery = gql`
    query UaTraitsQuery($dictNames: [GdStringDictNameInput]!) {
        reqId: getReqId
        constants {
            stringDicts(dictNames: $dictNames) {
                dictName
                entries {
                    ... on GdStringDictEntryWithLongKey {
                        key
                    }
                    value
                }
            }
        }
    }
`;
